import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
import { BarSkeletonItems } from './bar-skeleton-items';
import { ItemLegendDesk } from './item-legend-desk';
import { ItemLegendValues } from './item-legend-values';
import { LegendAxisYItems } from './legend-axis-y-items';
function BreakdownChartSkeleton() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Array.from({
      length: 12
    }, _temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const arrayLegendAxisX = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative flex w-full flex-row items-end gap-2 md:justify-start lg:gap-4 xl:gap-6 2xl:gap-6"><LegendAxisYItems /><BarSkeletonItems /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col">{t1}<div className="mt-2 hidden w-full flex-row items-center justify-between md:flex md:pl-19 lg:mt-3 lg:pl-24 xl:justify-start xl:gap-4.75 xl:pl-24 2xl:gap-6">{arrayLegendAxisX.map(_temp2)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full pl-10 md:hidden"><div className="mb-3 flex w-full flex-row items-end justify-between gap-2">{arrayLegendAxisX.map(_temp3)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-2 flex flex-row gap-1 overflow-hidden pl-8 md:hidden"><Skeleton className="border-input h-2.75 flex-1 rounded-l-[3px] rounded-r-none border-b border-l bg-transparent" /><Skeleton className="bg-input rounded-3 mx-3 mt-1 h-3 w-7" /><Skeleton className="border-input h-2.75 flex-1 rounded-l-none rounded-r-[3px] border-r border-b bg-transparent" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="relative flex w-full flex-col justify-center md:mt-0 md:h-67 md:max-w-[calc(100%-287px)] lg:h-72 lg:max-w-[calc(100%-416px)] xl:h-89 xl:max-w-[calc(100%-387px)] xl:pl-0 2xl:h-89 2xl:max-w-[calc(100%-450px)]">{t2}{t3}{t4}<div className="ml-8 flex flex-col flex-wrap items-center justify-center gap-6 gap-y-4 md:hidden"><ItemLegendValues /><ItemLegendValues /><ItemLegendValues /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex w-full flex-col items-center md:flex-row md:items-start md:justify-between md:gap-6 xl:gap-8">{t5}<div className="md:bg-accent hidden md:flex md:h-67 md:w-66 md:flex-col md:items-center md:gap-6 md:rounded-xl lg:h-72 lg:w-90.5 xl:h-88 xl:w-88 2xl:h-88 2xl:w-98"><div className="flex h-full flex-col justify-center gap-6"><ItemLegendDesk widthName={116} widthValue={50} /><ItemLegendDesk widthName={126} widthValue={51} /><ItemLegendDesk widthName={143} widthValue={44} /></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp3(__0, index_0) {
  return <div key={index_0} className="flex w-4 justify-center pt-1 text-end"><Skeleton className="h-2 w-2 rounded-full" /></div>;
}
function _temp2(_, index) {
  return <div key={index} className="flex w-9.5 flex-col items-center gap-1 md:h-4.75 md:w-6 lg:min-w-7.5 xl:min-w-10"><Skeleton className="bg-accent h-4.75 w-3 rounded-md" /></div>;
}
function _temp() {
  return 0;
}
export { BreakdownChartSkeleton };